import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { SnackbarProvider } from 'notistack'
import React, { lazy, Suspense } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { Route, Switch } from 'react-router-dom'
import Loading from './Components/Spinner'
import { ProvideAuth } from './Hooks/useAuth'
import ProtectedRoute from './ProtectedRoute'

const Login = lazy(() => import('./Pages/Auth/Login'))

const SuratKeluar = lazy(() => import('./Pages/Dashboard/SuratKeluar'))
const SuratMasuk = lazy(() => import('./Pages/Dashboard/SuratMasuk'))
const HistoriPengajuan = lazy(() => import('./Pages/Dashboard/HistoryPengajuan'))
const AllUsers = lazy(() => import('./Pages/Dashboard/AllUsers'))
const PengaturanAkun = lazy(() => import('./Pages/Dashboard/PengaturanAkun'))
const DetailDisposisi = lazy(() => import('./Pages/Dashboard/DetailsDisposisi'))

const theme = createMuiTheme({
    typography: {
        fontFamily: ['Be Vietnam', 'sans-serif'].join(','),
    },
})

const App = () => {
    const queryClient = new QueryClient()
    return (
        <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={theme}>
                <SnackbarProvider
                    maxSnack={3}
                    anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
                >
                    <ProvideAuth>
                        <Suspense fallback={<Loading />}>
                            <Switch>
                                <Route path="/" exact component={Login} />
                                <ProtectedRoute
                                    path="/dashboard/users/all"
                                    exact
                                    component={AllUsers}
                                />
                                <ProtectedRoute
                                    path="/dashboard/disposisi/keluar"
                                    exact
                                    component={SuratKeluar}
                                />
                                <ProtectedRoute
                                    path="/dashboard/disposisi/masuk"
                                    exact
                                    component={SuratMasuk}
                                />
                                <ProtectedRoute
                                    path="/dashboard/disposisi/riwayat"
                                    exact
                                    component={HistoriPengajuan}
                                />
                                <ProtectedRoute
                                    path="/dashboard/akun"
                                    exact
                                    component={PengaturanAkun}
                                />
                                <ProtectedRoute
                                    path="/dashboard/disposisi/:id"
                                    exact
                                    component={DetailDisposisi}
                                />
                            </Switch>
                        </Suspense>
                    </ProvideAuth>
                </SnackbarProvider>
            </ThemeProvider>
        </QueryClientProvider>
    )
}

export default App
